<div class="side-shell" [class.collapsed]="isCollapsed">
  <!-- Top branding -->
  <div class="sidebar-header" *ngIf="!isCollapsed">
    <app-branding></app-branding>
  </div>

  <div class="sidebar-scroll">
    <mat-nav-list class="sidebar-list">
      <!-- 🔹 Skeleton Loader -->
      <div *ngIf="isLoading" class="skeleton-loader">
        <div class="skeleton-group" *ngFor="let item of [1, 2, 3, 4]">
          <div class="skeleton-caption">
            <div class="skeleton-text skeleton-title"></div>
          </div>
          <div class="skeleton-children">
            <div class="skeleton-child" *ngFor="let child of [1, 2, 3]">
              <div class="skeleton-icon-small"></div>
              <div class="skeleton-text"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- 🔹 Sidebar Content -->
      <div *ngIf="!isLoading">
        <!-- Expanded View -->
        <div *ngIf="!isCollapsed" class="sidebar-expanded">
          <app-nav-item
            [sidenav]="sidenav"
            *ngFor="let item of navItems"
            (itemSelected)="onNavItemClicked($event)"
            [item]="item"
            [isCollapsed]="isCollapsed">
          </app-nav-item>
        </div>

        <!-- Collapsed View (Icons Only) -->
        <div *ngIf="isCollapsed" class="sidebar-collapsed">
          <app-nav-item
            [sidenav]="sidenav"
            *ngFor="let item of navItems"
            (itemSelected)="onNavItemClicked($event)"
            [item]="item"
            [isCollapsed]="isCollapsed">
          </app-nav-item>
        </div>
      </div>
    </mat-nav-list>
  </div>

  <!-- Bottom user card + logout -->
  <div class="sidebar-footer">
    <div class="user-card" *ngIf="!isCollapsed">
      <div class="user-avatar">
        <img [src]="userAvatarUrl" (error)="userAvatarUrl = defaultAvatarUrl" alt="User" />
      </div>
      <div class="user-meta">
        <div class="user-name">{{ userName }}</div>
        <div class="user-role">{{ userRole }}</div>
      </div>
    </div>

    <button
      mat-button
      class="logout-btn"
      (click)="logout()"
      [title]="isCollapsed ? 'Logout' : ''"
    >
      <mat-icon>logout</mat-icon>
      <span style="color: rgb(255, 255, 255);" *ngIf="!isCollapsed" class="logout-text">Logout</span>
    </button>
  </div>
</div>
